import { CommunicationsEventKind, CommunicationsEvent } from './event';
import { noop } from '../../../utilities/noop';
/**
 * Content communications handler methods
 */
var ContentCommunicationHandlerMethods = /** @class */ (function () {
    function ContentCommunicationHandlerMethods() {
        /**
         * Method to dispose the content.
         */
        this.dispose = noop;
        /**
         * Method to dispose the content.
         */
        this.handleDataEvent = noop;
    }
    return ContentCommunicationHandlerMethods;
}());
export { ContentCommunicationHandlerMethods };
/**
 * Handle the communications on the component content side.
 */
var ContentCommunicationHandler = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param communicationsManager A communications manager
     * @param methods The callback to dispose the content.
     */
    function ContentCommunicationHandler(communicationsManager, methods) {
        var _this = this;
        this.communicationsManager = communicationsManager;
        this.methods = methods;
        this.communicationsManager.setEventReceivedCallback(function (e) {
            _this.handleEvent(e);
        });
        this.disposed = false;
    }
    /**
     * Core functionality for handling the incoming events.
     *
     * @param e The event.
     */
    ContentCommunicationHandler.prototype.handleEventCore = function (e) {
        switch (e.kind) {
            case CommunicationsEventKind.BeforeDispose:
            case CommunicationsEventKind.Disposed:
                if (this.methods) {
                    this.methods.dispose();
                }
                break;
            case CommunicationsEventKind.Data:
                if (this.methods) {
                    this.methods.handleDataEvent(e.data);
                }
                break;
            default:
                throw new Error("The \"".concat(e.kind, "\" event is not configured."));
        }
    };
    /**
     * Handle the incoming communications event.
     *
     * @param e The event
     */
    ContentCommunicationHandler.prototype.handleEvent = function (e) {
        this.handleEventCore(e);
    };
    /**
     * Core dispose function.
     * Any component derived should override this to add clean-up after itself.
     */
    ContentCommunicationHandler.prototype.disposeCore = function () { };
    /**
     * Send a message.
     *
     * @param event The message.
     */
    ContentCommunicationHandler.prototype.send = function (event) {
        var _a;
        (_a = this.communicationsManager) === null || _a === void 0 ? void 0 : _a.send(event);
    };
    /**
     * Dispatch event to signal mounting finished.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    ContentCommunicationHandler.prototype.sendData = function (data) {
        var evt = new CommunicationsEvent(CommunicationsEventKind.Data);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        evt.data = data;
        this.send(evt);
    };
    /**
     * Dispatch event to signal mounting finished.
     */
    ContentCommunicationHandler.prototype.dispatchMounted = function () {
        this.send(new CommunicationsEvent(CommunicationsEventKind.Mounted));
    };
    /**
     * Dispatch event to signal update is about to start.
     */
    ContentCommunicationHandler.prototype.dispatchBeforeUpdate = function () {
        this.send(new CommunicationsEvent(CommunicationsEventKind.BeforeUpdate));
    };
    /**
     * Dispatch event to signal update finished.
     */
    ContentCommunicationHandler.prototype.dispatchUpdated = function () {
        this.send(new CommunicationsEvent(CommunicationsEventKind.Updated));
    };
    /**
     * Dispatch event to disposing started.
     */
    ContentCommunicationHandler.prototype.dispatchBeforeDispose = function () {
        this.send(new CommunicationsEvent(CommunicationsEventKind.BeforeDispose));
    };
    /**
     * Dispatch event to mount finished.
     */
    ContentCommunicationHandler.prototype.dispatchDisposed = function () {
        this.send(new CommunicationsEvent(CommunicationsEventKind.Disposed));
    };
    /**
     * Method invoked to dispose of the handler.
     */
    ContentCommunicationHandler.prototype.dispose = function () {
        var _a;
        if (this.disposed)
            return;
        this.disposed = true;
        this.disposeCore();
        (_a = this.communicationsManager) === null || _a === void 0 ? void 0 : _a.dispose();
        this.communicationsManager = null;
        this.methods = null;
    };
    return ContentCommunicationHandler;
}());
export { ContentCommunicationHandler };
//# sourceMappingURL=contentHandler.js.map